import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import AllHome from "./Components/AllHome/AllHome";
import LatestProject from "./Components/AllHome/LatestProject/LatestProject";

function App() {
  return (
    <div>
      <Router>
        <Switch>
          <Route exact path="/">
            <AllHome></AllHome>
          </Route>
          <Route path="/home">
            <AllHome></AllHome>
          </Route>
          <Route path="/project">
            <LatestProject></LatestProject>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
